import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";
const initialState = {
    orderApprovalAuthority: [],
};
let URL = endpoints.orderApprovalAuthority;
const orderApprovalAuthoritySlice = createSlice({
    name: "orderApprovalAuthority",
    initialState,
    reducers: {
        orderApprovalAuthoritySuccess: (state = cloneDeep(initialState), action) => {
            const { row } = action.payload;
            return {
                ...state,
                orderApprovalAuthority: row,
            };
        },

        resetState: (state = cloneDeep(initialState), action) => {
            return {
                ...state,
                ...initialState,
            };
        },
    },
});

export const { orderApprovalAuthoritySuccess, resetState } = orderApprovalAuthoritySlice.actions;

export default orderApprovalAuthoritySlice.reducer;

export const getOrderApprovalAuthority = () => async (dispatch) => {
    try {
        const response = apiGet({
            url: URL + "/get-all",
        }).then(({ data, success }) => {
            if (success) {
                const row = data.data.map((otherTaskObject, index) => {
                    let otherTaskData = {
                        index: index + 1,
                        id: otherTaskObject.id === null ? "" : otherTaskObject.id,
                        salesTeamId: otherTaskObject.salesTeamId === null ? "" : otherTaskObject.salesTeamId,
                        salesTeamName:
                            otherTaskObject.salesTeamName !== null && otherTaskObject.salesTeamTypePrefix !== null
                                ? otherTaskObject.salesTeamName + " (" + otherTaskObject.salesTeamTypePrefix + ")" : "",
                        salesTeamTypeName: otherTaskObject.salesTeamTypeName === null ? "" : otherTaskObject.salesTeamTypeName,
                        salesTeamTypePrefix: otherTaskObject.salesTeamTypePrefix === null ? "" : otherTaskObject.salesTeamTypePrefix,
                        authorityId: otherTaskObject.authorityId === null ? "" : otherTaskObject.authorityId,
                        authorityName:
                            otherTaskObject.authorityName !== null && otherTaskObject.authorityTypePrefix !== null
                                ? otherTaskObject.authorityName + "(" + otherTaskObject.authorityTypePrefix + ")" : "",
                        authorityTypeId: otherTaskObject.authorityTypeId === null ? "" : otherTaskObject.authorityTypeId,
                        authorityTypeName: otherTaskObject.authorityTypeName === null ? "" : otherTaskObject.authorityTypeName,
                        authorityTypePrefix: otherTaskObject.authorityTypePrefix === null ? "" : otherTaskObject.authorityTypePrefix,
                        distributorId: otherTaskObject.distributorId === null ? "" : otherTaskObject.distributorId,
                        stockHolderName:
                            otherTaskObject.distributorFirmName !== null && otherTaskObject.distributorTypePrefix !== null
                                ? otherTaskObject.distributorFirmName + " (" + otherTaskObject.distributorTypePrefix + ")" : "-",
                        distributorTypeName: otherTaskObject.distributorTypeName === null ? "" : otherTaskObject.distributorTypeName,
                        distributorTypePrefix: otherTaskObject.distributorTypePrefix === null ? "" : otherTaskObject.distributorTypePrefix,
                        isActive:
                            otherTaskObject.isActive === null ? "" : otherTaskObject.isActive,

                    };
                    return otherTaskData;
                });
                dispatch(orderApprovalAuthoritySuccess({ row }));
                return { response: row, success };
            }
            return { response: [], success };
        });
        return response;
    } catch (e) {
        return console.error(e.message);
    }
};
